import { render, staticRenderFns } from "./PackageDetailsView.vue?vue&type=template&id=43266a6a&"
import script from "./PackageDetailsView.vue?vue&type=script&lang=ts&"
export * from "./PackageDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageDetailsView.vue"
export default component.exports